<template>
	<div class="my-table managementDetailPage">
		<!-- 面包屑组件 -->
		<div class="searchBox flexCenter pb30">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span class="link">{{$t('managementDetail.txt1')}} <i class="goBackTxt" @click="goBackFistPage">{{$t('managementDetail.txt2')}}</i> / {{isAdmin ? $t('managementDetail.txt3') : $t('managementDetail.txt4')}} 
					<span class="link pathC" @click="toRootPath">{{detail.home}}</span>
					<span v-for="(item, index) in paths" :key="item.path" @click="handleFlooder(index)"> / 
						<span class="link" > {{item.localPath}} </span>
					</span>
				</span>
			</div>
			<div class="flexEnd">
				<div class="searchBtn ml20" @click="goImport">{{$t('managementDetail.txt8')}} </div>
				<el-dropdown @command="selectUploadType">
					<div class="searchBtn ml20">{{$t('managementDetail.txt5')}} </div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="file">{{$t('managementDetail.txt6')}} </el-dropdown-item>
						<el-dropdown-item command="dir">{{$t('managementDetail.txt7')}} </el-dropdown-item>
						<el-dropdown-item command="data"> </el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<span class="searchBtn ml20" @click="handleApplyDownload" v-if="!isAdmin">{{$t('managementDetail.txt9')}} </span>
				<div class="searchBtn ml20" @click="handleDownload" v-loading="downloadLoading" v-else>{{$t('managementDetail.txt10')}} </div>
				<div class="searchBtn ml20" @click="goProjectMembers">{{$t('managementDetail.txt11')}} </div>
				<div class="searchBtn ml20" v-if="isAdmin" @click="goProjectSettings">{{$t('managementDetail.txt12')}} </div>
				<div class="searchBtn ml20" @click="onBack">{{$t('managementDetail.txt13')}} </div>
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card class="tableCard mt0">
			<el-table ref="mainTable" :data="dataList" max-height="600px" @selection-change="handleSelectionChange" >
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column :label="$t('managementDetail.txt14')"  width="50px">
					<template slot-scope="scope">
						<span>{{scope.$index+1}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('managementDetail.txt15')">
					<template slot-scope="scope">
						<div class="flex align-center link" @dblclick="handleOpenFolder(scope.row)">
							<img :src="scope.row.directory ? fileTypes.folder : (fileTypes[scope.row.fileType] || fileTypes.system)" class="mr-10" width="30"/>
							<span v-if="scope.row.directory">
								<span v-if="!scope.row.changeName">{{scope.row.localPath}}</span>
								<el-input v-else class="inputProjectName" v-model="scope.row.localPath" @blur="confirmProjName" :placeholder="$t('managementDetail.txt16')"></el-input>
							</span>
							<span v-else>
								<span>{{scope.row.localPath}}</span>
							</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column :label="$t('managementDetail.txt17')" >
					<template slot-scope="scope">
						<span v-if="scope.row.directory">--</span>
						<span v-else>{{scope.row.createDate | formatDate}}</span>
					</template>
				</el-table-column>
				<el-table-column :label="$t('managementDetail.txt18')" width="310">
					<template slot-scope="scope">
						<div>
							<el-button v-if="isAdmin" @click="handleRename(scope.row)" class="handleBtn" type="text">{{$t('managementDetail.txt19')}}</el-button>
							<el-button @click="handleApply(scope.row)" v-if="!isAdmin" class="handleBtn" type="text">{{$t('managementDetail.txt20')}}</el-button>
							<el-button @click="download(scope.row)" class="handleBtn" type="text" v-else>{{$t('managementDetail.txt21')}}</el-button>
							<el-button v-if="isAdmin" class="handleBtn" @click="handleDelete(scope.row)" type="text">{{$t('managementDetail.txt22')}}</el-button>
							<!-- <el-button  class="handleBtn"  @click="authoritySettings(scope.row)" type="text">权限设置</el-button> -->
						</div>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		<div class="table-footer tablePagination  mt-50" v-show="total>0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="queryInfo.pageNum" :page-sizes="[10, 20, 30, 40]"
					layout="total, sizes, prev, pager, next" :page-size="queryInfo.pageSize"
					:total="total">
			</el-pagination>
		</div>
		<edit :visible.sync="dialogFormAddVisible" :isEdit="true" :addProjectInfo.sync="editDetail"
			@success="loadData"></edit>
        <!-- 上传我的数据 -->
        <el-dialog :title="$t('managementDetail.txt23')" :visible.sync="dialogFormVisible" :closeOnClickModal="false">
        	<div class="searchBox flexCenter searchBoxBreak">
			  <div class="current-location">
			    <img class="location" src="@/assets/picture/icon/location.png">
			    <span>{{$t('managementDetail.txt24')}}</span>
			    <span class="pathC" @click="toRootPathA">{{$t('managementDetail.txt25')}}</span>
			    <span v-for="(item, index) in pathsA" :key="item.path" @click="handleFlooderA(index)"> / <span class="link" > {{item.path?item.path:item.localPath}}</span></span>
			</div>
		</div>
			<el-table ref="table" :data="allDataList" 
        	@selection-change="handleSelectionChangeData" >
        	<el-table-column type="selection" width="55"></el-table-column>
        	<el-table-column :label="$t('managementDetail.txt26')"  width="50px">
        		<template slot-scope="scope">
        			<span>{{scope.$index+1}}</span>
        		</template>
        	</el-table-column>
        	<el-table-column :label="$t('managementDetail.txt27')">
        		<template slot-scope="scope">
        			<div class="flex align-center link" @dblclick="handleOpenFolderA(scope.row)">
        				<img :src="scope.row.directory ? fileTypes.folder : (fileTypes[scope.row.fileType] || fileTypes.system)" class="mr-10" width="30"/>
        				<span v-if="scope.row.directory">
        					<span v-if="!scope.row.changeName">{{scope.row.path}}</span>
        					<el-input v-else class="inputProjectName" v-model="scope.row.localPath" @blur="confirmProjName" placeholder="$t('managementDetail.txt28')"></el-input>
        				</span>
        				<span v-else>
        					<span>{{scope.row.path}}</span>
        				</span>
        			</div>
        		</template>
        	</el-table-column>
        	<el-table-column :label="$t('managementDetail.txt29')" >
        		<template slot-scope="scope">
					<span v-if="scope.row.directory">--</span>
					<span v-else>{{scope.row.createDate | formatDate}}</span>
        		</template>
        	</el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
        	<el-button type="primary" @click="handleImportData" class="confirmbtn">{{$t('managementDetail.txt30')}}</el-button>
        	<el-button class="cancelbtn" @click="handleCancel">{{$t('managementDetail.txt31')}}</el-button>
        </div>
    </el-dialog>
	<u-dialog :title="$t('managementDetail.txt32')" width="600px" :visible.sync="visibleDownloadModal" @confirm="confirmDownload">
		<div class="download-box">
			<p class="p1">{{$t('managementDetail.txt33')}}</p>
			<p class="p2">{{$t('managementDetail.txt34')}}</p>
			<p class="p2">{{$t('managementDetail.txt35')}}</p>
		</div>
	</u-dialog>
	   <!-- 文件上传重名 -->
  <el-dialog
  class="repeatBox"
  :title="$t('myDoc.txt34')"
  :visible.sync="dialogVisible"
  width="30%">
  <span>{{$t('myDoc.txt35')}}</span>
  <span slot="footer" class="el-message-box__btns">
    <el-button @click="dialogVisible = false">{{$t('myDoc.txt36')}}</el-button>
    <el-button @click="onRepeatUpload(1)">{{$t('myDoc.txt37')}}</el-button>
    <el-button type="primary" @click="onRepeatUpload(2)">{{$t('myDoc.txt38')}}</el-button>
  </span>
</el-dialog>
    <input type="file" id="fileUpload" class="upload-btn" ref="fileInput" @change="uploadFile">
    <input type="file"  id="dirUpload" class="upload-btn" ref="fileInput2" webkitdirectory @change="uploadFile">
</div>
</template>

<script>
	import edit from './components/edit';
	import { downloadFile } from '@/utils/fileRequest';
	import { formatDate } from "@/plugins/date.js";
	import { fileTypes, getFileSize } from '@/utils/index';
	const cityOptions = [];
	//   import 
	import qs from 'qs';
	export default {
		components: {
			edit
		},
		data() {
			return {
				// userOptions: [],
				fileTypes,
				dialogFormAddVisible:false,
				id: this.$route.query.id,
				detail: {},
				editDetail: {},
				multipleSelectionData:[],
				multipleSelection: [],
				checkAll: false,
				checkedCities: [],
				dialogFormVisible:false,
				cities: cityOptions,
				isEditDetail: true, //项目详情是否编辑状态
				isEditIntroduce: true, //项目介绍是否编辑状态
				visibleTitle: '',
				isIndeterminate: true,
				time: '',
				formData: {}, //详情参数
				inputValue: '', //项目标签添加参数
				options: [], //测试数据
				//用于获取数据列表
				queryInfo: {
					cmptName: '',
					endCreateTm: '',
					pageNum: 1,
					pageSize: 10,
					productTmplCmptId: '',
					projName: '',
					spvTm: '',
					startCreateTm: '',
					submitterName: '',
					witnCde: '',
					witnType: '',
				},
				fileList: [],
				dataList: [],
				total: 0,
				paths: [],
				pathsA: [{path:'SyncFolder'}],
				isList: true,
				loading: false,
				isAdmin:false,//是否为本项目的管理员，true当前用户为该项目的管理员
				downloadLoading: false,
				visibleDownloadModal:false,
				nowPaths:[],
				allDataList:[],
				uploadType:'file',//上传类型，file为文件，dir为文件夹
                dialogVisible:false,//文件上传检测重名
                event:null,//上传事件
                fileName:'',//上传文件夹/文件名称\
                newName:'',//检查是否重名，直接用返回的newName
				uploading: false, //正在上传
                progress: 0, //上传进度条
			};
		},
		created() {
			this.getDetail();
			this.loadData();
			this.getAllData();
		},
		computed: {
			currentPath() {
				let { paths } = this;
				if(!paths.length) return '';
				return paths[paths.length - 1].path
			},
			currentPathA() {
				let { pathsA } = this;
				if(!pathsA.length) return '';
				return pathsA[pathsA.length - 1].path
			},
		},
		filters: {
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, "yyyy-MM-dd");
			},
		},
		methods: {
			goBackFistPage(){
				this.$router.push("/managementProject"); 
			},
			onBack(){
    		  this.$router.go(-1);
    		},
			// 获取项目详情
            async getDetail(){
                let { currentPath } = this;
                const { data: res } = await this.$http.post("/project/detail?id=" + this.id);
                if (!res.success) {
					return this.$message.error(res.message);
				}
				if(res.result.admin.id === localStorage.userId) {
					this.isAdmin = true;
				}
				this.detail = res.result;
            },
    		// 数据加载
            async loadData(){
                let { currentPath } = this;
                const { data: res } = await this.$http.post("/project/files?path=" + currentPath+'&projectId='+this.$route.query.id);
                if (!res.success) {
					return this.$message.error(res.message);
				}
				// if(res.result.admin.id === localStorage.userId) {
				// 	this.isAdmin = true;
				// }
				res.result && res.result.forEach(item => {
					item.localPath = item.path.replace(new RegExp('^' + currentPath + '/'), '')
					if(item.directory) {
						item.changeName = false;
					}
					else {
						item.fileType = this.getFileType(item.path)
					}
				})
				this.dataList = res.result;
				// this.getFileList()
            },
			// 获取所有数据
			async getAllData(){
                let { currentPathA } = this;
                const { data: res } = await this.$http.post("/user/info/disk?path=" + currentPathA);
                this.loading = false;
                if(!res.success){
                    return this.$message.error(res.message);
                }
                res.result && res.result.forEach(item => {
                    item.localPath = item.path.replace(new RegExp('^' + currentPathA + '/'), '')
                    if(item.directory) {
                        item.changeName = false;
                    }
                    else {
                        item.fileType = this.getFileType(item.path)
                    }
                })
                this.allDataList = res.result || [];
            },
			async confirmDownload() {
                const data = {
                    "applyUser":{"id":localStorage.userId},
                    "project":{"id": this.id},
                    "paths": this.nowPaths
                }
                const {data: res} = await this.$http.post('/download/apply/add', data)
                if(!res.success) {
                    this.$message.warning(res.message)
                }else{
					this.$message.success(this.$t('managementDetail.txt36'))
				}                
                this.visibleDownloadModal = false;
            },
			toRootPath() {
				this.paths = [];
				this.loadData()
			},
			toRootPathA(){
				this.pathsA = []
				this.getAllData()
			},
			handleApply(row){
				this.nowPaths = [];
				this.nowPaths.push(row.path);
				this.visibleDownloadModal = true;
			},
			// 导入
			goImport(){
				this.dialogFormVisible = true;
			},
			handleApplyDownload() {
                this.getSelection().then(async list => {
					this.nowPaths = list;
                    this.visibleDownloadModal = true;
                })
            },
			// 双击进入文件内
			handleOpenFolder(item){
				this.multipleSelection = [];
				this.paths.push(item)
				this.loadData();
			},
			// 上传我的数据-双击进入文件内
			handleOpenFolderA(item){
				this.multipleSelectionData = [];
				this.pathsA.push(item)
				this.getAllData();
			},
			handleFlooder(index) {
				this.paths = this.paths.slice(0, index + 1);
				this.loadData()
			},
			handleFlooderA(index) {
				this.pathsA = this.paths.slice(0, index + 1)
				this.getAllData()
			},
			async getFileList() {
				let { currentPath, id } = this;
				const data = {
					projectId: id,
					path: currentPath.slice(1)
				}
				this.loading = true
				const { data: res } = await this.$http.post("/project/files?" + qs.stringify(data));
				this.loading = false;
				if(!res.success){
					return this.$message.error(res.message);
				}
				res.result && res.result.forEach(item => {
					item.localPath = item.path.replace(new RegExp('^' + currentPath + '/'), '')
					if(item.directory) {
						item.changeName = false;
					}
					else {
						item.fileType = this.getFileType(item.path)
					}
				})
				this.dataList = res.result || [];
			},
			getFileType(name) {
				let arr = name.split('.')
				return arr[arr.length - 1];
			},
			// 重命名
			handleRename(row){
				let { currentPath, id } = this;
				console.log(currentPath,'currentPath');
				this.$prompt('', this.$t('managementDetail.txt37'), {
					confirmButtonText: this.$t('managementDetail.txt38'),
					cancelButtonText: this.$t('managementDetail.txt39'),
					inputValue: row.localPath,
				}).then(async ({value}) => {
					let data = {
						projectId:this.id,
						name:currentPath?currentPath+'/'+row.localPath:row.localPath,
						newName:currentPath?currentPath+'/'+value:value
					}
					const { data: res } = await this.$http.post("/project/renameFile?"+qs.stringify(data));
					if(!res.success){
						return this.$message.error(res.message);
					}
					this.$message({
						type: 'success',
						message: this.$t('managementDetail.txt40')
					});
					this.loadData();
				})
			},
			// 权限设置
			authoritySettings(row){
				let file = '';
				if(this.paths.length == 0){
					file = row.path;
				}else{
					file = this.paths[this.paths.length-1].path +row.path;
				}
				this.$router.push("/authoritySettings?id=" + this.id+'&file='+file);
			},
			selectUploadType(type) {
				console.log(type,'type')
				switch(type) {
					case 'file':
						this.uploadType = 'file';
						window.sessionStorage.setItem("uploadType",this.uploadType);
						window.sessionStorage.setItem("projectId",this.$route.query.id);
						this.$refs.fileInput.click()						
						break;
					case 'dir':
						this.uploadType = 'dir';
						window.sessionStorage.setItem("uploadType",this.uploadType);
						window.sessionStorage.setItem("projectId",this.$route.query.id);
						this.$refs.fileInput2.click()
						break;
					default:
						return
				}
			},
			async uploadFile(e) {
				// console.log(e,'e');
				// if(this.uploadType == 'file'){
                //    var upload = document.getElementById('fileUpload');
                //    console.log(upload,'upload1')
                //    // 获取文件名
                //      this.fileName = upload.files[0].name;
                // }else{
                //    var theFiles = e.target.files;
                //     var relativePath = theFiles[0].webkitRelativePath;
                //     var folder = relativePath.split("/");
                //    // 获取文件名
                //    this.fileName = folder[0];
                // }
                // console.log(this.fileName,'fileName')
                // this.event = e;
                // // 获取上传文件大小
                // let totalSize = 0;
                // let files =  e.target.files;
                // for (let i = 0; i < files.length; i++) {
                //     totalSize += files[i].size;
                // }   
                // console.log("Total size:", totalSize);
                // // 字节转换成MB
                //  let byte = (totalSize / (1024 * 1024)).toFixed(2);
                //  console.log(byte,byte)
                // // 统计文件总大小是否大于500M
                // if(byte>500){
                //     // 启动客户端
                //     this.startClient();
                // }else{
                //     // 调用接口检查是否有同名文件
                //     this.checkFileSameName(e);
                // }

				if(this.uploading){
                    this.$message({
                        message: '当前任务正在进行中,任务完成后再上传!',
                        type: 'warning'
                    });
                    return;
                }

                //新的上传方式
                const notification = this.$notify({
                    //title: '上传进度',
                    message: '<progress id="uploadProgress" max="100" value="0" ></progress><span style="font-size:14px;margin-left: 5px;" id="uploadProgressText"></span>',
                    position: 'bottom-right',
                    offset: 100,
                    showClose: false, //不显示关闭按钮
                    dangerouslyUseHTMLString: true, // 关键：允许解析HTML
                    duration: 0, // 关键：设置为0表示不自动关闭
                    customClass: 'custom-upload-notify' // 添加自定义类名
                });

				// if(this.uploadType == 'file'){
                //     var upload = document.getElementById('fileUpload');
                //     console.log(upload,'upload1')
                //     // 获取文件名
                //     this.fileName = upload.files[0].name;
                // }else{
                //     var theFiles = e.target.files;
                //     var relativePath = theFiles[0].webkitRelativePath;
                //     var folder = relativePath.split("/");
                //     // 获取文件名
                //     this.fileName = folder[0];
                // }

				let { currentPath } = this;
				console.log(currentPath)

				if(this.uploadType == 'file'){
                    var upload = document.getElementById('fileUpload');
                    // 获取文件名
                    this.fileName = upload.files[0].name;

                    const files = e.target.files;
                    if (files.length === 0) return;

                    this.uploading = true;
                    this.progress = 0;

                    const formData = new FormData();                    
                    //上传到的目录
                    formData.append('dir', currentPath);
					formData.append('projectId',this.$route.query.id)
                    // 添加所有文件到FormData（保留目录结构）
                    Array.from(files).forEach(file => {
                        formData.append('files', file);
                    });
                    try {
                        const response = await this.$http.post(
                        '/project/uploadFile',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            onUploadProgress: (progressEvent) => {
                                if (progressEvent.total) {
                                    this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                    console.log(this.progress)                                    
                                    var uploadProgress = document.getElementById('uploadProgress');
                                    uploadProgress.value = this.progress;

                                    var uploadProgressText = document.getElementById('uploadProgressText');
                                    uploadProgressText.innerHTML = this.progress+"%";
                                }
                            }
                        }
                        );
                        console.log('上传成功:', response.data);
                        //alert('文件上传成功！');
                        this.loadData(); //加载文件列表
                    } catch (error) {
                        console.error('上传失败:', error);
                        //alert('上传失败，请检查控制台');
                    } finally {
                        this.uploading = false;
                        e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
                        notification.close() //关闭进度条
                    }

                }else{ //文件夹

                    //    var theFiles = e.target.files;
                    //    var relativePath = theFiles[0].webkitRelativePath;
                    //    var folder = relativePath.split("/");
                    //    // 获取文件名
                    //    this.fileName = folder[0];
                    const files = e.target.files;
                    if (files.length === 0) return;
                
                    this.uploading = true;
                    this.progress = 0;
                
                    const formData = new FormData();                
                    //上传到的目录
                    formData.append('dir', currentPath);
					formData.append('projectId',this.$route.query.id)
                
                    // 添加所有文件到FormData（保留目录结构）
                    Array.from(files).forEach(file => {
                        formData.append('files', file, file.webkitRelativePath);
                    });
                
                    try {
                        const response = await this.$http.post(
                            '/project/uploadFolder',
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                },
                                onUploadProgress: (progressEvent) => {
                                    if (progressEvent.total) {
                                        this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                            console.log(this.progress)                                 
                                            var uploadProgress = document.getElementById('uploadProgress');
                                            uploadProgress.value = this.progress;

                                            var uploadProgressText = document.getElementById('uploadProgressText');
                                            uploadProgressText.innerHTML = this.progress+"%";
                                    }
                                }
                            }
                        );
                
                        console.log('上传成功:', response.data);
                        //alert('文件夹上传成功！');
                        this.loadData(); //加载文件列表
                    } catch (error) {
                        console.error('上传失败:', error);
                        //alert('上传失败，请检查控制台');
                    } finally {
                        this.uploading = false;
                        e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
                        notification.close() //关闭进度条
                    }
                }

			},
			          // 启动客户端
          startClient(path){
            let downloadFilePath = path?path:'';
            let loginName = window.sessionStorage.getItem("loginName");
             var info = JSON.stringify({
              username: loginName, // 用户名，当前登录的账号名
              server: "http://"+window.location.hostname+":36003", //服务端地址，开发时获取浏览器的ip用拼接: "http://"+window.location.hostname+":36003"
              // downloadFilePath: '/home/sysmanager/file1', //自动下载的文件路径,file1是文件路径绝对路径，如果单纯的打开客户端，这里留空即"",即可
              downloadFilePath: downloadFilePath, //
              downloadIsDir:  path?true:false //自动下载的是不是文件夹，文件夹: true, 文件: false
            })
            // 生成拉起App的地址
            var url = window.StartAppUrl(info);
            window.location.href = url;
			this.$refs.fileInput.value = '';
			this.$refs.fileInput2.value = '';
          },
         // 检查上传文件是否同名
        async checkFileSameName(e){
            let { currentPath } = this;
            let isUploadFolder = this.uploadType == 'file'?false:true;//是否为文件夹
            // let fileName = this.$store.state.fileName;
            // let fileName =window.sessionStorage.getItem("fileName");
            const { data: res } = await this.$http.get("/project/checkFileSameName?path=" + currentPath+'&fileName='+this.fileName+'&isUploadFolder='+isUploadFolder+'&projectId='+this.$route.query.id);
            if(!res.success){
                return this.$message.error(res.message);
            }
            this.newName = res.result.newName;
            // 若tag为1,则说明该文件重名
           if(res.tag== 1){
            this.dialogVisible = true;
           }else{
           	this.onRepeatUpload(1);
    //        	this.$store.dispatch('UPLOAD', {
				// 	event: e,
				// 	path: this.currentPath,
				// 	url: '/project/upload',
				// 	operation:1,
				// 	query: {
				// 		projectId: this.id
				// 	},
				// 	mkdirUrl: `/project/mkdir?projectId=${this.id}&`,
				// 	cb: () => {
				// 		e.target.value = null
				// 		this.loadData();
				// 	}
				// })
           }
        },
                // 文件重命名上传
        onRepeatUpload(type){
            let operation = type;   //重名时用到,上传操作,0:忽略,1:覆盖,2:保存两者,3:继续上传
            this.dialogVisible = false;
              console.log(this.uploadType,'uploadType')
            let fileName =window.sessionStorage.getItem("fileName");
             let url = this.uploadType == 'file'?'/project/upload':'/project/upload/folder';
            	this.$store.dispatch('UPLOAD', {
            	  url: url,
            	  event: this.event,
            	  path: this.currentPath,
            	  operation:operation,
            	  uploadNewFileName:this.newName,
            	  // uploadNewFileName:this.fileName,
            	  cb: () => {
            	    this.event.target.value = null;
            	    this.loadData();
            	}
            })
			this.$refs.fileInput.value = '';
			 this.$refs.fileInput2.value = '';
        },
			getSelection() {
				return new Promise((resolve) => {
					if(this.isList) {
						if(this.multipleSelection.length) {
							resolve(this.multipleSelection.map(item =>item.path))
						}
						else {
							this.$message.warning(this.$t('managementDetail.txt41'))
						}
					}
					else {
						const list = this.$refs.diskMain.checkedList;
						if(list.length) {
							resolve(list)
						} 
						else {
							this.$message.warning(this.$t('managementDetail.txt41'))
						}
					}
				})

                // return new Promise((resolve) => {
                //     if(this.isList) {
                //         if(this.multipleSelection.length) {
                //             resolve(this.multipleSelection)
                //         }
                //         else {
                //             this.$message.warning('请至少选择一个文件或者文件夹')
                //         }
                //     }
                //     else {

                //     }
                // })
            },
            getSizeSelection() {
				return new Promise((resolve) => {
					if(this.isList) {
						if(this.multipleSelection.length) {
							resolve(this.multipleSelection.map(item =>item.size))
						}
						else {
							this.$message.warning(this.$t('managementDetail.txt41'))
						}
					}
					else {
						const list = this.$refs.diskMain.checkedList;
						if(list.length) {
							resolve(list)
						} 
						else {
							this.$message.warning(this.$t('managementDetail.txt41'))
						}
					}
				})
            },
            // 项目成员
            goProjectMembers(){
            	this.$router.push("/projectMembers?id=" + this.id);
            },
            // 项目设置
            goProjectSettings(){
            	this.$router.push("/projectSettings?id=" + this.id);
            },
            // 删除
            async handleDelete(row){
            	// let list = await this.getSelection()
            	// const { currentPath } = this;
				let list = [];
				list.push(row.path);
            	this.$confirm('<p class="color666 fz14">'+this.$t('managementDetail.txt42')+'</p><p class="color999 fz14">'+this.$t('managementDetail.txt43')+'</p>', '删除', {
            		dangerouslyUseHTMLString: true,
            		confirmButtonText: this.$t("managementDetail.txt44"),
            		cancelButtonText: this.$t("managementDetail.txt45"),
            		type: 'warning',
            		center: true,
            	}).then(e => {
                    // list = list.map(item => item.path.slice(1));
                    list = list.map(item => item.slice(1));
                    this.confirmDeleteDir(list)
                })
            },
            async confirmDeleteDir(list) {
            	const { data: res } = await this.$http.post("/project/files/delete?projectId=" + this.id, JSON.stringify(list));
            	if(!res.success){
            		return this.$message.error(res.message);
            	}
            	this.$message({
            		type: 'success',
            		message: this.$t("managementDetail.txt46")
            	});
            	this.getFileList();
            },
			async handleDownload() {
				this.getSelection().then(async list => {

					var projectId  = this.detail.id;
					console.log(projectId)

                    if(this.uploading){
                        console.log("任务进行中,请稍后!")
                        this.$message({
                            message: '任务进行中,请稍后!',
                            type: 'warning'
                        });
                        return;
                    }
                    const notification = this.$notify({
                        //title: '上传进度',
                        message: '<progress id="uploadProgress" max="100" value="0" ></progress><span style="font-size:14px;margin-left: 5px;" id="uploadProgressText"></span>',
                        position: 'bottom-right',
                        offset: 100,
                        showClose: false, //不显示关闭按钮
                        dangerouslyUseHTMLString: true, // 关键：允许解析HTML
                        duration: 0, // 关键：设置为0表示不自动关闭
                        customClass: 'custom-upload-notify' // 添加自定义类名
                    });                          
                
                    //隐藏进度条，只显示中文即可
                    var uploadProgress = document.getElementById('uploadProgress');
                    uploadProgress.style.display = 'none';

                    var uploadProgressText = document.getElementById('uploadProgressText');
                    uploadProgressText.innerHTML = "正在打包中,请稍等";
                                    
                    let lists = list.map(item => item)
                    if(lists.length>1){
                        this.$message.warning(this.$t("myDoc.txt41"))
                        return
                    }
                    console.log(lists,'lists')
                    console.log( this.dataList,'this.dataList')    

                    this.uploading = true;
                    this.progress = 0;
                    try {
                        const response = await this.$http.post('/project/getDownloadFilePath?projectId=' + projectId ,JSON.stringify(lists));
                        console.log('获取url', response.data);

                        const zip = response.data.result;
                        console.log(zip)
                        var url = this.$http.defaults.baseURL + "/project/download?path=" + zip;
                        console.log(url)

                        //创建隐藏的<a>标签
                        const link = document.createElement("a");
                        link.href = url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        
                    } catch (error) {
                        console.error('获取url失败:', error);
                        //alert('上传失败，请检查控制台');
                    } finally {
                        this.uploading = false;
                        // e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
                        //稍后关闭进度条
                        setTimeout(() => {
                            notification.close() //关闭进度条
                        }, 800);                            
                    }                    
                })

            },
			// 单个文件下载
			async download(row){
				// let lists = [];
				// lists.push(row.path)
				// const hasElementWithoutExtension = lists.some(item => !/\.[^.]+$/.test(item));
                // // true，表示数组中存在任意一个元素没有后缀名,则存在文件夹
                // if(hasElementWithoutExtension){
                //   let projectName = this.detail.projectName;
                //   let basePath = this.detail.basePath;
                //   //启动客户端
                //   let downloadFilePath = basePath +projectName+'/'+lists;
                //   this.startClient(downloadFilePath);
                // }else{
                // // 获取上传文件大小
               	//  let totalSize = Number(row.size);
               	//  // 字节转换成MB
               	//  let byte = (totalSize / (1024 * 1024)).toFixed(2);
               	//  // 统计文件总大小是否大于500M
               	//  if(byte>500){
               	//  // 启动客户端
               	//  	 let projectName = this.detail.projectName;
               	//       let basePath = this.detail.basePath;
               	//       //启动客户端
               	//       let downloadFilePath = basePath +projectName+'/'+lists;
               	//       this.startClient(downloadFilePath);
               	//  	return;
               	// 	}
				// 	let list = [];
				// 	list.push(row.path);
				// 	let data = {
            	// 		projectId:this.id,
            	// 		paths:list.map(item => item)
            	// 	}
				// 	// try{
            	// 		// this.downloadLoading = true;
            	// 		let queryData = {
            	// 			projectId:this.id,
            	// 			paths:list.map(item => item)
            	// 		}
            	// 		const res = await downloadFile('post', '/project/download',queryData)
				// 		if(res){
				// 			this.$message.success(this.$t("managementDetail.txt47"))
            	// 			// this.downloadLoading = false
            	// 			this.multipleSelection = [];
            	// 			this.$refs.diskMain.checkedList = [];
				// 		}else{
				// 			// this.downloadLoading = false;
				// 			this.$message.error(this.$t("managementDetail.txt48"))
				// 		}
            	// 	// }
            	// 	// catch(e) {
            	// 	// 	this.downloadLoading = false;
            	// 	// 	this.$message.error(this.$t("managementDetail.txt48"))
            	// 	// 	console.log(e)
            	// 	// }
                // }

				var projectId  = this.detail.id;
				console.log(projectId)
				

				if(this.uploading){
					console.log("任务进行中,请稍后!")
					this.$message({
						message: '任务进行中,请稍后!',
						type: 'warning'
					});
					return;
				}
				const notification = this.$notify({
					//title: '上传进度',
					message: '<progress id="uploadProgress" max="100" value="0" ></progress><span style="font-size:14px;margin-left: 5px;" id="uploadProgressText"></span>',
					position: 'bottom-right',
					offset: 100,
					showClose: false, //不显示关闭按钮
					dangerouslyUseHTMLString: true, // 关键：允许解析HTML
					duration: 0, // 关键：设置为0表示不自动关闭
					customClass: 'custom-upload-notify' // 添加自定义类名
				});                          
			
				//隐藏进度条，只显示中文即可
				var uploadProgress = document.getElementById('uploadProgress');
				uploadProgress.style.display = 'none';

				var uploadProgressText = document.getElementById('uploadProgressText');
				uploadProgressText.innerHTML = "正在打包中,请稍等";
								
				let lists = [];
				lists.push(row.path)
				if(lists.length>1){
					this.$message.warning(this.$t("myDoc.txt41"))
					return
				}
				console.log(lists,'lists')
				console.log( this.dataList,'this.dataList')    

				this.uploading = true;
				this.progress = 0;
				try {
					const response = await this.$http.post('/project/getDownloadFilePath?projectId=' + projectId ,JSON.stringify(lists));
					console.log('获取url', response.data);

					const zip = response.data.result;
					console.log(zip)
					var url = this.$http.defaults.baseURL + "/project/download?path=" + zip;
					console.log(url)

					//创建隐藏的<a>标签
					const link = document.createElement("a");
					link.href = url;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					
				} catch (error) {
					console.error('获取url失败:', error);
					//alert('上传失败，请检查控制台');
				} finally {
					this.uploading = false;
					// e.target.value = ''; // 清空选择的文件(必须清空，不然第二次无法再次选文件)
					//稍后关闭进度条
					setTimeout(() => {
						notification.close() //关闭进度条
					}, 800); 
				}                           

			},
            // 进入文件夹
            openFloder(item) {
            	this.paths.push(item)
            	this.getFileList();
            },
            handleEdit() {
            	const data = JSON.parse(JSON.stringify(this.detail))
            	data.userInfos = data.userInfos.map(item => item.id)
            	this.editDetail = data;
            	this.dialogFormAddVisible = true;
            },
			// 新增项目标签
			async handleInputConfirm() {
				if(this.inputValue == '') {
					return 
				}
				let formData = {
					tagName: this.inputValue,
					projectId: this.id
				};
				const { data: res } = await this.$http.post("/project/add/tag?" + qs.stringify(formData));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message.success(this.$t("managementDetail.txt49"))
				this.inputValue = '';
				this.loadData();
			},
			// 上传我的数据取消操作
			handleCancel(){
				this.dialogFormVisible = false;
				// 重置勾选
			},
			handleUpload() {
				this.$refs.fileInput.click()
			},
			async deleteTag(tag) {
				let formData = {
					tagId: tag.id,
					projectId: this.id
				};
				const {
					data: res
				} = await this.$http.post("/project/delete/tag?" + qs.stringify(formData));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message.success(this.$t("managementDetail.txt50"))
				this.loadData();
			},
			async deleteUser(user) {
				let formData = {
					userId: user.id,
					projectId: this.id
				};
				const {
					data: res
				} = await this.$http.post("/project/delete/user?" + qs.stringify(formData));
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message.success(this.$t("managementDetail.txt51"))
				this.loadData();
			},
			// 页面切换
			handleCurrentChange(page) {
				this.queryInfo.page = page;
				this.loadData();
			},
			handleSizeChange(size){
				this.queryInfo.size = size;
				this.loadData();
			},
			// 全选
			handleSelectionChange(selectdata) {
				let arrays;
            if (selectdata.length >= 2) {
               arrays = selectdata.splice(0, selectdata.length - 1);
               arrays.forEach((row) => {
               this.$refs.mainTable.toggleRowSelection(row);
            });
            }
				this.multipleSelection = selectdata;
			},
			// 上传我的数据-全选
			handleSelectionChangeData(val){
				this.multipleSelectionData = val;
			},
			// 上传我的数据-提交
			handleImportData(){
				if(this.multipleSelectionData){
					let { currentPath, id } = this;
					let data = {
					  fileList: [],
					  projectId: id,
					  toPath: '/'+currentPath
					}
					this.multipleSelectionData.map(e=>{
						data.fileList.push('/'+e.path);
					})
					this.importDataFromMyData(data);

				}else{
					this.$message.error(this.$t("managementDetail.txt52"))
				}
			},
			// 从我的数据导入
			async importDataFromMyData(formData) {
				const {
					data: res
				} = await this.$http.post("/project/importDataFromMyData",formData);
				if (!res.success) {
					return this.$message.error(res.message);
				}
				this.$message.success(this.$t("managementDetail.txt53"))
				this.dialogFormVisible = false;
				this.loadData();
			},
			handleCheckAllChange(val) {
				this.checkedCities = val ? cityOptions : [];
				this.isIndeterminate = false;
			},
			handleCheckedCitiesChange(value) {
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
			},
		},
	};
</script>

<style lang="less" scoped>
	.managementDetailPage {
		margin: -1rem;
		.goBackTxt{
			font-style:normal;
		}
		.searchBoxBreak{
			margin-top: 10px;
		}
		/deep/ .el-dialog__body{
			min-height: 20vh;
			overflow-y: scroll;
		}
		/deep/ .el-table td, .el-table th{
			background-color: #fff !important;
		}
		/deep/ .repeatBox{
			.el-dialog__body{
				padding: 1rem 3.6rem 0 3.6rem !important;
				padding-top: 1rem;
				height: auto !important;
			}
			/deep/ .el-dialog .el-dialog__body .el-select .el-input__inner, .el-dialog .el-dialog__body .el-input__inner, .el-dialog .el-dialog__body .el-input{
            border-radius: 8px;
        	}
        	.el-message-box__btns{
        	    width: 100% !important;
        	    display: flex;
        	    .el-button--primary{
        	        border-radius: 50px;
        	    }
        	}
		}
		.addBtn {
			border: none;
		}
		.searchBox .flex{
			position: absolute;
			right: 0;
		}
		.table-header {
			margin: 0 2rem;
		}
		.showType{
			font-size: 1.4rem;
			font-weight: 400;
			color: #1B3B7C;
			height: 30px;
			line-height: 30px;
			cursor: pointer;
		}
		.back {
			margin-bottom: 2.4rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}

		/deep/ .el-dialog__body{
			padding-top: 0;
			.el-table td, .el-table th{
				padding: 12px 0 !important;
			}
		}
		.cardContent {
			padding: 2.1rem 2.1rem 3rem 2.1rem;
			border: 1px solid #F4F4F4;
			box-shadow: 0rem 0rem 2rem 0rem rgba(202, 204, 204, 0.3);
			border-radius: 1rem;
			margin: 0 2rem 2rem;

			.header {
				padding-bottom: 2rem;
				border-bottom: 1px solid #CBCBCB;

				/deep/ .el-input__inner {
					border: 1px solid #C0C0C0;
					// border-right:none;
					height: 100%;
				}

				/deep/ .el-input-group {
					width: 32rem;
					height: 3rem;
				}

				/deep/ .el-input-group__append {
					border: 1px solid #C0C0C0;
					border-left: none;
					padding: 0;
					background: #fff;
				}

				/deep/ .el-input-group__append button.el-button {
					padding: 0;
					width: auto;
					margin-right: 1.1rem;
				}

				.editInput {
					margin-right: 10px;
					/deep/ .el-input__inner {
						width: 16rem;
						height: 2.4rem;
					}
				}

				.btnTxt {
					font-size: 1.4rem;
					font-weight: 400;
					color: #1B3B7C;
					margin-right: 2rem;
					cursor: pointer;
					min-width: 3em;
					line-height: 2.4rem;
				}

				.btnTxt:last-of-type {
					margin-right: 0;
				}

				.subTitle:before {
					content: '';
					display: inline-block;
					width: 0.3rem;
					height: 1.5rem;
					background: #1B3B7C;
					border-radius: 5px;
					margin-right: 1rem;
				}

				.subTitle {
					font-size: 1.6rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #333333;
				}
			}

			.pt0 {
				padding-top: 0 !important;
			}

			.contentBox {
				padding-top: 2.9rem;

				.w32 {
					width: 32rem;
				}

				/deep/ .el-form-item {
					margin-bottom: 0rem;

					.el-form-item__label {
						color: #666;
						font-size: 1.4rem;
					}
				}

				/deep/ .el-input__inner {
					height: 3rem;
				}

				.txt {
					font-size: 1.4rem;
					font-weight: 400;
					color: #333;
					line-height: 4rem;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				/deep/ .el-tag {
					/*padding:0.5rem 1.2rem;*/
					border-radius: 5px;
					border: 1px solid #999;
					font-size: 1.4rem;
					color: #333;
					background: #fff !important;
					margin-right: 2.4rem;
					height: 1.3rem;
					display: initial;

					.el-tag__close {
						color: #D3D3D3 !important;
					}
				}

				.selectAll {
					padding: 3.7rem 3rem 1.7rem 3rem;

					.headerTXT:first-of-type {
						margin-left: 2.8rem;
					}

					;

					.headerTXT {
						font-size: 1.4rem;
						color: #999;
						margin-right: 3.1rem;
					}
				}
				
				.latticeShow {
					ul {
						li:hover {
							background: #DAE4F9;
						}

						;

						li:nth-of-type(4n) {
							margin-right: 0;
						}

						li {
							margin-bottom: 2rem;
							width: 22%;
							float: left;
							padding: 1rem;
							cursor: pointer;
							border-radius: 10px;
							background: #F4F4F4;
							margin-right: 4%;

							.el-checkbox {
								display: block;
							}

							img {
								width: 4.8rem;
								height: 3.9rem;
								margin: 0 1rem;
							}

							p:first-of-type {
								font-size: 1.4rem;
								font-weight: 400;
								color: #333333;
								line-height: 2.1rem;
							}

							p:nth-of-type(2) {
								font-size: 1.2rem;
								font-weight: 400;
								color: #999;
								line-height: 2.1rem;

								span {
									color: #666;
									margin: 0 0.5rem;
								}
							}
						}
					}
				}
			}
		}
	}

	.empty{
		color: #666;
		text-align: center;
	}
	.upload-btn{
		position: fixed;
		width: 0;
		height: 0;
		pointer-events: none;
		display: none;
		opacity: 0;
		top: 0;
		left: 0;
		cursor: pointer;
	}
	.download-box{
		padding-bottom: 30px;
		p{
			margin-bottom: 20px;
		}
		.p1{
			color: #666
		}
		.p2{
			color: #333
		}
		.email-box{
			display: flex;
			justify-content: center;
			color: #666;
			line-height: 2.3rem;
			.email{
				background: #E6EEFF;
				padding: 0 1.4rem;
				height: 2.3rem;
				border-radius: 4px;;
			}
		}
	}
	.theme_black{
		.download-box{
			padding-bottom: 80px;
			.p1{
				color: #666
			}
			.p2{
				color: #fff
			}
		}
	}
	.pathC{
    cursor: pointer;
}
</style>
